import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from '../models/api-response.model';
import { Observable } from 'rxjs';
import { Registration } from '../models/registration.model';

@Injectable({ providedIn: 'root' })
export class SurveyService {
  constructor(private httpClient: HttpClient) {}

  getBySaleItemUuids(saleItemUuids: string[], organizationId: string): Observable<ApiResponse<Registration[]>> {
    const url: string = environment.apiUri + '/ngin/registration/surveys';
    const params = {
      organization_id: organizationId,
      sale_item_uuids: saleItemUuids.join(','),
      fields: 'id,name,survey_url',
      status_not: '-1',
    };

    return this.httpClient.get<ApiResponse<Registration[]>>(url, { params, ...this.getOptions() });
  }

  private getOptions(): object {
    return {
      withCredentials: true,
      headers: {
        Accept: 'application/json',
      },
    };
  }
}
